<ion-card
  *ngIf="surveyLink && surveyLink !== ''"
  class="survey"
  (click)="openSurvey()"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'tablet'
        : 'mobile'
      : 'desktop'
  "
>
  <div class="survey-text-container">
    <div class="survey-first">
      <span data-cy="survey-text">
        {{ 'i18n.profilePage.survey.title' | translate }}
      </span>
    </div>
    <div class="survey-second">
      <div data-cy="survey-text">
        {{ 'i18n.profilePage.survey.description' | translate }}
      </div>
    </div>
  </div>
  <div>
    <ion-button data-cy="survey-button" class="usf-outline-green-button">
      {{ 'i18n.profilePage.survey.button' | translate }}
    </ion-button>
  </div>
</ion-card>
